import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import BankForm from "./BankForm";

const BankFormItems = () => {
  const [stripe, setStripe] = useState<Stripe | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadStripeAsync = async () => {
      const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

      if (!stripeKey) {
        setError('Stripe publishable key is not configured');
        return;
      }

      try {
        const stripeInstance = await loadStripe(stripeKey);
        setStripe(stripeInstance);
      } catch (err) {
        setError('Failed to load Stripe');
      }
    };

    loadStripeAsync();
  }, []);

  if (error) {
    return <div className="text-red-600">{error}</div>;
  }

  if (!stripe) {
    return null;
  }

  return (
    <Elements stripe={stripe}>
      <BankForm />
    </Elements>
  )
}
export default BankFormItems;
